import { gql } from "lib/apolloClient";

import { aiTutorAwardEntryFragment } from "./AITutorAwardsFragments";

export const createAITutorAwardEntryMutation = gql`
  mutation createAITutorAwardEntry($input: CreateAiTutorAwardEntryInput!) {
    planner {
      createAiTutorAwardEntry(input: $input) {
        isSuccess
        warning
        response {
          ...aiTutorAwardEntryDetails
        }
      }
    }
  }
  ${aiTutorAwardEntryFragment}
`;

export const updateAITutorAwardEntriesMutation = gql`
  mutation updateAITutorAwardEntries($input: UpdateAiTutorAwardEntriesInput!) {
    planner {
      updateAiTutorAwardEntries(input: $input) {
        isSuccess
        warning
        response {
          id
          review
        }
      }
    }
  }
`;

export const createAITutorAwardNominationsMutation = gql`
  mutation createAITutorAwardNominations(
    $input: CreateAiTutorAwardNominationsInput!
  ) {
    planner {
      createAiTutorAwardNominations(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
